import React from "react";

import Link from "core/Link";

import { LinkContainer } from "./styles";

const UploadsLinks = ({ userUploads, username }) => {
    const linkProps = {
        size: "md",
        styleType: "primary"
    };

    if (username && userUploads) {
        return (
            <LinkContainer>
                {userUploads.hasApprovedUploads ? (
                    <Link href="/dashboard/uploads" {...linkProps}>
                        View All Uploads
                    </Link>
                ) : null}
                {userUploads.pendingCount ? (
                    <Link href={`/${username}/uploads/pending`} {...linkProps}>
                        {userUploads.pendingCount} Awaiting Moderation
                    </Link>
                ) : null}
                {userUploads.deniedCount ? (
                    <Link href={`/${username}/uploads/denied`} {...linkProps}>
                        {userUploads.deniedCount} Denied
                    </Link>
                ) : null}
            </LinkContainer>
        );
    }

    return null;
};

export default UploadsLinks;
